import {
  iconInformational01,
  iconWarning01,
  iconSuccess
} from '@bukalapak/bazaar-token';

export default {
  default: iconInformational01,
  applied: iconSuccess,
  error: iconWarning01,
}
